import { sites, hotSites } from '@/mocks/navigation';
import SiteCard from '@/components/base/SiteCard';

export default function HotSites() {
  const hotSiteData = hotSites.map((id) => sites.find((s) => s.id === id)).filter(Boolean) as typeof sites;

  return (
    <section className="py-10 md:py-14 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">热门推荐</h2>
            <p className="mt-1.5 text-sm text-foreground-600">编辑精选，大家都在用的优质网站</p>
          </div>
          <div className="hidden sm:flex items-center gap-1 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
            <i className="ri-fire-line"></i>
            <span>每日更新</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-product-shop="">
          {hotSiteData.map((site) => (
            <SiteCard
              key={site.id}
              name={site.name}
              url={site.url}
              description={site.description}
              tags={site.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}